import { css } from 'styled-components';
import { fluidSpaceLg } from '../../utilities/fluid/fluid';
/**
 * @deprecated since 2.10.2023
 * For spacing, reference the customTheme's space key (src/ui/views/root/custom-theme.ts) using styled system props, sx prop, or themeGet function.
 */
export enum BouSpacingLevel {
  /**
   * Same as 160 pixels in Bou design
   */
  EXTRA_LARGE = 'EXTRA_LARGE',
  /**
   * Same as 100 pixels in Bou design
   */
  LARGE = 'LARGE',

  /**
   * Same as 80 pixels in Bou design
   */
  MEDIUM = 'MEDIUM',

  /**
   * Same as 60 or 65 pixels in Bou design
   */
  SMALL = 'SMALL',

  /**
   * Same as 40 pixels in Bou design
   */
  EXTRA_SMALL = 'EXTRA_SMALL',

  /**
   * Same as 30 pixels in Bou design
   */
  TINYISH = 'TINYISH',

  /**
   * Same as 20 pixels in Bou design
   */
  TINY = 'TINY',

  /**
   * Same as 10 pixels in Bou design
   */
  MICRO = 'MICRO',
}

/**
 * @deprecated since 2.10.2023
 * For spacing, reference the customTheme's space key (src/ui/views/root/custom-theme.ts) using styled system props, sx prop, or themeGet function.
 */
export function fluidSpacing(cssProperty: string, level: BouSpacingLevel) {
  return fluidSpaceLg(cssProperty, referenceSpacing(level));
}

/**
 * @deprecated since 2.10.2023
 * For padding, reference the customTheme's space key (src/ui/views/root/custom-theme.ts) using styled system props, sx prop, or themeGet function.
 */
export function fluidVerticalPadding(level: BouSpacingLevel) {
  return css`
    ${fluidSpacing('padding-top', level)};
    ${fluidSpacing('padding-bottom', level)};
  `.join('');
}

/**
 * @deprecated since 2.10.2023
 * For padding, reference the customTheme's space key (src/ui/views/root/custom-theme.ts) using styled system props, sx prop, or themeGet function.
 */
export function fluidHorizontalPadding(level: BouSpacingLevel) {
  return css`
    ${fluidSpacing('padding-left', level)};
    ${fluidSpacing('padding-right', level)};
  `.join('');
}

/**
 * @deprecated since 2.10.2023
 * For padding, reference the customTheme's space key (src/ui/views/root/custom-theme.ts) using styled system props, sx prop, or themeGet function.
 */
export function fluidPadding(level: BouSpacingLevel) {
  return css`
    ${fluidSpacing('padding', level)};
  `.join('');
}

/**
 * @deprecated since 2.10.2023
 * For margin, reference the customTheme's space key (src/ui/views/root/custom-theme.ts) using styled system props, sx prop, or themeGet function.
 */
export function fluidVerticalMargin(level: BouSpacingLevel) {
  return css`
    ${fluidSpacing('margin-top', level)};
    ${fluidSpacing('margin-bottom', level)};
  `.join('');
}

/**
 * @deprecated since 2.10.2023
 * For margin, reference the customTheme's space key (src/ui/views/root/custom-theme.ts) using styled system props, sx prop, or themeGet function.
 */
export function fluidHorizontalMargin(level: BouSpacingLevel) {
  return css`
    ${fluidSpacing('margin-left', level)};
    ${fluidSpacing('margin-right', level)};
  `.join('');
}

/**
 * @deprecated since 2.10.2023
 * For margin, reference the customTheme's space key (src/ui/views/root/custom-theme.ts) using styled system props, sx prop, or themeGet function.
 */
export function fluidMargin(level: BouSpacingLevel) {
  return css`
    ${fluidSpacing('margin', level)};
  `.join('');
}

/**
 * Return the spacing for the level as measured
 * from Bou's 1920px designs
 */
export function referenceSpacing(level: BouSpacingLevel): number {
  switch (level) {
    case BouSpacingLevel.EXTRA_LARGE:
      return 160;
    case BouSpacingLevel.LARGE:
      return 100;
    case BouSpacingLevel.MEDIUM:
      return 80;
    case BouSpacingLevel.SMALL:
      return 60; // 65 in design but constant scale would be 60
    case BouSpacingLevel.EXTRA_SMALL:
      return 40;
    case BouSpacingLevel.TINYISH:
      return 30;
    case BouSpacingLevel.TINY:
      return 20;
    case BouSpacingLevel.MICRO:
      return 10;
  }
}
